import axios from 'axios';
import Config from '../../api/Confing.json';

class ApiService {
    constructor() {
        this.baseUrl = Config.basePath;
        this.preFix = Config.preFix;
        this.paths = Config.paths;
    }

    request(apiName, params = {}, body = {}, headers = {}) {
        const api = this.paths[apiName];
        if (!api) {
            throw new Error(`API name "${apiName}" not found in config.`);
        }

        let url = this.baseUrl + api.path;
        if (params) {
            Object.keys(params).forEach((key) => {
                url = url.replace(`{${key}}`, params[key]);
            });
        }

        const user = JSON.parse(sessionStorage.getItem("user"));
        const token = user?.token;

        const options = {
            method: api.method,
            url,
            data: body,
            headers: {
                Authorization: `Bearer ${token}`,
                ...headers, 
            },
        };

        return axios(options)
            .then((response) => response)
            .catch((error) => {
                console.error(`Error in API request: ${apiName}`, error);
                throw error;
            });
    }
}

export default new ApiService();
